import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, EyeOff, Zap, TrendingDown } from 'lucide-react';
export function BonusProblem() {
  return <section className="w-full py-16 px-6" style={{
    backgroundColor: 'var(--light-navy)'
  }} data-id="element-239">
      <div className="max-w-2xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-241">
          <div className="flex items-center gap-2 mb-4" data-id="element-242">
            <span className="w-3 h-3 rounded-full bg-red-500" data-id="element-243" />
            <span className="text-sm font-bold tracking-wider uppercase" style={{
            color: 'var(--navy)'
          }} data-id="element-244">
              Bloque 1
            </span>
          </div>
          <h2 className="font-serif text-2xl md:text-3xl mb-6" style={{
          color: 'var(--navy)'
        }} data-id="element-245">
            El problema que tienen en común los 3 bonos
          </h2>
          <p className="text-lg" style={{
          color: 'var(--charcoal)'
        }} data-id="element-246">
            Hay tres razones por las que la deuda no baja — aunque querás que
            baje.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-247">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex gap-4" data-id="element-248">
            <div className="flex-shrink-0 mt-1" data-id="element-249">
              <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(27, 42, 74, 0.1)'
            }} data-id="element-250">
                <EyeOff className="w-5 h-5" style={{
                color: 'var(--navy)'
              }} data-id="element-251" />
              </div>
            </div>
            <div data-id="element-252">
              <h3 className="font-bold text-lg mb-2" style={{
              color: 'var(--navy)'
            }} data-id="element-253">
                La primera es dinero que ya está saliendo y no ves.
              </h3>
              <p style={{
              color: 'var(--charcoal)',
              opacity: 0.8,
              lineHeight: '1.6'
            }} data-id="element-254">
                Suscripciones olvidadas. Trials que se volvieron pagos
                automáticos. Servicios duplicados. Renovaciones anuales. Todo
                corriendo en silencio, todos los meses, sin que lo decidas
                conscientemente.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex gap-4" data-id="element-255">
            <div className="flex-shrink-0 mt-1" data-id="element-256">
              <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(27, 42, 74, 0.1)'
            }} data-id="element-257">
                <Zap className="w-5 h-5" style={{
                color: 'var(--navy)'
              }} data-id="element-258" />
              </div>
            </div>
            <div data-id="element-259">
              <h3 className="font-bold text-lg mb-2" style={{
              color: 'var(--navy)'
            }} data-id="element-260">
                La segunda es dinero que sale por impulso.
              </h3>
              <p style={{
              color: 'var(--charcoal)',
              opacity: 0.8,
              lineHeight: '1.6'
            }} data-id="element-261">
                En el momento del deseo no tenés ninguna herramienta más rápida
                que el impulso. El sistema está diseñado para que gastes —
                one-click, BNPL, "oferta limitada" — y vos no tenés reglas
                listas para ese momento específico.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex gap-4" data-id="element-262">
            <div className="flex-shrink-0 mt-1" data-id="element-263">
              <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(27, 42, 74, 0.1)'
            }} data-id="element-264">
                <TrendingDown className="w-5 h-5" style={{
                color: 'var(--navy)'
              }} data-id="element-265" />
              </div>
            </div>
            <div data-id="element-266">
              <h3 className="font-bold text-lg mb-2" style={{
              color: 'var(--navy)'
            }} data-id="element-267">
                La tercera es dinero que nunca llega a la deuda.
              </h3>
              <p style={{
              color: 'var(--charcoal)',
              opacity: 0.8,
              lineHeight: '1.6'
            }} data-id="element-268">
                No porque no quieras. Sino porque no sabés con exactitud cuánto
                es "seguro" pagar extra sin quedarte corto. Entonces esperás. Y
                casi nunca sobra.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-10 p-6 rounded-xl text-center font-medium text-lg" style={{
        backgroundColor: 'white',
        border: '1px solid var(--gold)',
        color: 'var(--navy)'
      }} data-id="element-269">
          Tres problemas distintos. Tres fugas distintas. Tres herramientas
          distintas para cerrarlas.
        </motion.div>
      </div>
    </section>;
}